// extracted by mini-css-extract-plugin
module.exports = {"sc0nf69":"sc0nf69","s55zdp0":"s55zdp0"};